import { createLogger } from 'shared/services/logger';
import us from '../../defines';
import {setIconState} from '../../toolbar';
import {Point} from '../../lib/objects/';
import {triggerUScopeEvent} from '../../_uScope';
import * as CONSTANTS from './constants';
import {translate} from 'shared/services/I18nService';
const $t = translate.scope('uScope.extensions.conferencing');

const logger = createLogger('UScope:extensions:ConferencingService');

//    This file contains the uScope portion of the Conferencing Service, for both leader and joiner
//    of a conference in conjunction with DSCClient.  It also contains cConfTestPanel which
//    provides unit testing of uScope's conferencing features.
//
//    Design notes:
//        Conference Leader Role:
//            - recvs VIL-issued join conference event specifies role of leader or becomes leader
//                on VIL-issued leaderChange event
//            - recvs VIL-issued exit event and no longer performs conferencing actions
//            - note that the leader's tray can open, close, and change attributes such as positive/negative control
//                 of an image and that VIL recvs tray actions to be transmitted to the followers  via the DSC server
//
//        Conference Follower Role:
//            - recvs VIL-issued join conference event specifies role of follower or becomes follower
//                on VIL-issued leaderChange event
//            - recvs VIL-issued view and marker events, updates the view and marker states
//            - recvs VIL-issued exit event and no longer performs conferencing actions
//            - note that the follower's tray can open, close, and change attributes such as positive/negative
//                control of an image in response to VIL-issued events originating from the leader's tray
//
//    Handy conferencing URLs
//            http://localhost/dscserver/RESET        to clear all current conferences
//            http://localhost/dscserver/STATS        to see if a conference is running
//

// Compatibility only. confEvents is defined in AIH to conference folder
const confEvent = window.confEvent || {};

// Main class
export default function ConferencingService (uScopeInstance) {
  let uScope = uScopeInstance;
  var self = this;
  var bAmInConf_;
  var bAmLeader_;

  var thisImg;
  var namespace_ = '.usconference';
  var confMarkerLT_ = new Point(0, 0);

  var minViewMovePx_ = 6; // the minimum distance in pixels of view change to respond to

  // ............................................ queries public
  this.isInConference = function () {
    return bAmInConf_;
  };
  this.isConfLeader = function () {
    return (bAmInConf_ && bAmLeader_);
  };
  this.isConfMember = function () {
    return (bAmInConf_ && (!bAmLeader_));
  };

  // ____________________________________________________________________________________________
  //     CONFERENCE EVENTS TO VIL FROM CONFERENCE INITIATOR
  // ____________________________________________________________________________________________

  // ............................................ confCreate public
  //    This function fires an event indicating the user wants to create a conference.
  this.confCreate = function () {
    if (confEvent.createBtn) {
      triggerConfEvent(confEvent.createBtn, {src: 'uScope'});
    }
  };

  this.setUScope = uScopeInstance => { uScope = uScopeInstance; };

  // ____________________________________________________________________________________________
  //     LOCAL FUNCTIONS
  // ____________________________________________________________________________________________
  // ............................................ triggerConfEvent
  // triggerConfEvent - This function fires the passed event with the passed parameters.
  var triggerConfEvent = function (evName, parms) {
    $(document).trigger(evName, parms);
  };
    // ............................................ bindEvents_() local
    //    This function is called when joining a conference.
  var bindEvents_ = function () {
    // ............................................ confEvent.openimage
    // Listen for a conference open image event.
    // {src: 'uScope', imageId: @NUM, uScopeIdx: NUM, 'imagePath': STR }
    $(document).on(confEvent.openimage + namespace_, function (e, json) {
      if (self.isInConference() == true && self.isConfLeader() == false) {
        if (json == undefined) {
          logger.error('Error: confEvent.openimage: json input undefined');
          return;
        }
        logger.log('recieved', confEvent.openimage, json);
        thisImg = uScope.getThisImage();
        if (thisImg == undefined) { // no image in view, so open the passed image
          let imageSet1 = {
            'images': [{
              'imagePath': json.imageId,
              'fullURL': json.imagePath, // the image that is opening
              x: json.x,
              y: json.y,
              zoom: json.zoom,
              angle: json.angleDeg
            }]
          };
          uScope.imageUpdate('add', imageSet1.images);

          thisImg = uScope.getThisImage(); // now reference to the newly opened image
        } else { // uScope already has an image, so replace it with this one
          let imageSet1 = {'images': [{'imagePath': thisImg.getImageId()}]}; // the image that is closing
          // NOTE: the mess here is that 'imagePath' means the fullURL to the conference and it means the imageId to uScope.
          var imageSet2 = {
            'images': [{
              'imagePath': json.imageId,
              'fullURL': json.imagePath,
              x: json.x,
              y: json.y,
              zoom: json.zoom,
              angle: json.angleDeg
            }]
          }; // the image that is opening
          uScope.imageUpdate('replace', imageSet1.images, imageSet2.images);

          thisImg = uScope.getThisImage(); // now reference to the newly opened image
        }

        if (thisImg) {
          // angle is not handled in the general, non-conference, image opening yet - if ever
          if (json.angleDeg) {
            if (json.angleDeg !== thisImg.getViewAngle(true)) { // update the view rotation if it has changed
              // todo: rotation angle here
            }
          }

          if (json.MarkerX && json.MarkerY) { // if a marker position is present
            confMarkerLT_.set(json.MarkerX, json.MarkerY); // update the marker position
            triggerUScopeEvent(CONSTANTS.CONFERENCE_MARKER_EVENT, json); // and fire event of conferencing follower's marker position update
          }
          triggerConfEvent(confEvent.imageChange, {src: 'uScope', imageId: thisImg.getImageId()}); // tell listeners (like slide tray) that image has changed (from no image to first image of conference)
        }
      }
    });
    // ............................................ confEvent.closeimage
    // Listen for a conference close image event.
    // {src: 'uScope', imageId: @NUM }
    $(document).on(confEvent.closeimage + namespace_, function (e, json) {
      if (self.isInConference() == true && self.isConfLeader() == false) {
        logger.log('recieved', confEvent.closeimage, json);

        var imageSet = {'images': [{'imagePath': json.imageId}]};
        uScope.imageUpdate('remove', imageSet.images);
      }
    });

    // ............................................ confEvent.leadChange
    // Listen for a conference leadership change event.
    $(document).on(confEvent.leadChange + namespace_, function (e, json) {
      if (self.isInConference() == true) {
        if (json == undefined) {
          logger.error('Error: confEvent.leadChange: json input undefined');
          return;
        }
        logger.log('recieved', confEvent.leadChange, json);
        var newLeaderState = (json.lead == true);
        if (bAmLeader_ != newLeaderState) {
          bAmLeader_ = newLeaderState;
          roleInit_(); // bind/unbind events depending upon leader/follower role
        }
      }
    });

    // ............................................ confEvent.update
    // Listen for a conference view change event and
    //    If this is the conference leader, do nothing
    //    If this is a conference follower, update the image views accordingly
    //
    // where json = {imageId: @NUM, x: baseCoordX, y: baseCoordY, zoom: viewZoom, angle: viewAngleDeg };
    $(document).on(confEvent.update + namespace_, function (e, json) {
      if (self.isConfLeader() == true) {
        // nothing to do, actually won't even see this event
      } else {
        // todo: consider issuing an internal event (that checks if it is already at this pos,zoom,angle and if so does nothing)
        if (json == undefined) {
          logger.error('Error: confEvent.update: json input undefined');
          return;
        }
        logger.log('recieved', confEvent.update, json);
        var thisImg = uScope.getThisImageById(json.imageId); // thisImg is vp of the passed imageId to update

        if (thisImg == undefined) { // open thisImg if it is not the currently opened image
          triggerConfEvent(confEvent.imageChange, {src: 'uScope', imageId: json.imageId});

          thisImg = uScope.getThisImage();
          var imageSet1;
          if (thisImg == undefined) { // no image in view,
            imageSet1 = {'images': [{'imagePath': json.imageId, 'fullURL': json.imagePath}]}; // the image that is opening
            uScope.imageUpdate('add', imageSet1.images);

            thisImg = uScope.getThisImage(); // now reference to the newly opened image
          } else { // uScope has an image, replace it with this one
            imageSet1 = {'images': [{'imagePath': thisImg.getImageId()}]}; // the image that is closing
            // NOTE: the mess here is that 'imagePath' means the fullURL to the conference and it means the imageId to uScope.
            /// //remove me //////    var imageSet2 = { 'images': [{ 'imagePath': json.imageId, 'fullURL': buildFULLURL_(json.imageId)}] }; //the image that is opening
            var imageSet2 = {'images': [{'imagePath': json.imageId, 'fullURL': json.imagePath}]}; // the image that is opening

            uScope.imageUpdate('replace', imageSet1.images, imageSet2.images);

            thisImg = uScope.getThisImage(); // now reference to the newly opened image
          }

          return; // note!  to prevent a race condition that the vp is not fully initialized and so cannot zoom or pan, get out now
        }

        if (thisImg) {
          // prevent race conditions (image switched and view or marker change followed fast before vp was initialized
          if (thisImg.isInitialized() == false) { return; }

          if (json.zoom && json.zoom !== thisImg.getViewZoom()) { // update the view zoom if it has changed
            thisImg.zoomAbsolute(json.zoom);
          }

          if (json.x && json.y) {
            var cpCenter = thisImg.getViewCenter(true); // xform coords?        // update the view center if it has changed
            var ptNewCenter = new Point(json.x, json.y);
            if (ptNewCenter.cityBlockDistance(cpCenter) > minViewMovePx_) { thisImg.moveAbsolute(ptNewCenter.x - thisImg.getViewWidth() / 2, ptNewCenter.y - thisImg.getViewHeight() / 2, us.coordSystemNORM); }
          }
          if (json.z) {
            // todo: zstack position here
          }
          if (typeof json.angleDeg !== 'undefined') {
            if (json.angleDeg !== thisImg.getViewAngle(true)) { // update the view rotation if it has changed
              thisImg.viewRotate(json.angleDeg);
            }
          }
          if (json.MarkerX && json.MarkerY) { // if a marker position is present
            if (json.MarkerX != confMarkerLT_.x || json.MarkerY != confMarkerLT_.y) { // and if it has changed
              confMarkerLT_.set(json.MarkerX, json.MarkerY); // then update the marker position
              triggerUScopeEvent(CONSTANTS.CONFERENCE_MARKER_EVENT, json); // and fire event of conferencing follower's marker position update
            }
          }
        } else {
          logger.error('... Error: conf: view change requested of image that is not opened: ' + json.imageId);
        }
      }
    });

    // Hide conferencing icon for pinned images, because only unpinned image is opened in a conference (and pinned are closed at start)
    // This function was pulled from Annotations because yea it makes total sense for conferencing to be part of annotations. There's
    // some kind of bleed over that we will need to decouple thought. TODO - reverse engineer what the hell is going on here and fix it.
    const namespace = '.annotpanel';
    const jRoot = $(us.idHashROOT);
    jRoot.on(us.evIMAGESELECTED + namespace, function (e, parms) {
      var thisImg = uScope.getThisImage();
      setIconState($('#' + CONSTANTS.CREATE_BUTTON_ID), CONSTANTS.CREATE_BUTTON_ID, thisImg.isPinned() ? 'disabled' : 'enabled');
    });
  };

    // ............................................ bindEventsOff_ local
    //    This function is called when exiting a conference.
  var bindEventsOff_ = function () {
    $(us.idHashROOT).off(namespace_);
  };
    // ............................................ roleInit_ local
    //    roleInit_ -  This function binds/unbinds events according to the conference participant's role.
    //    Specifically the conference leader monitors uScope-internal events evVIEWCHANGE and evMOUSECHANGE
  var roleInit_ = function () {
    logger.log('conf: roleInit_: as ' + ((self.isConfLeader() == true) ? 'Leader' : 'Follower'));
    if (self.isConfLeader() == true) {
      // enable the next/prev slide toolbar buttons
      setIconState($('.' + us.clsTBNEXTSLIDE), us.clsTBNEXTSLIDE, 'enabled');
      setIconState($('.' + us.clsTBPREVSLIDE), us.clsTBPREVSLIDE, 'enabled');

      // as conference leader, listen for internal view change event and fire conference view event
      $(us.idHashROOT).on(us.evIMAGEREADY, function (e, parms) {
        if (sendOpenImage_(parms.imageId) == false) {
          logger.error('conf: evIMAGEREADY event received but I cannot get thisImage: ' + parms.imageId);
        }
      });
      $(us.idHashROOT).on(us.evIMAGECLOSE, function (e, parms) {
        var json = {'src': 'uScope', 'imageId': parms.imageId};
        logger.log('sending', confEvent.imageclose, json);
        triggerConfEvent(confEvent.imageclose, json); // fire event to close image
      });

      triggerUScopeEvent(CONSTANTS.CONFERENCE_MARKER_EVENT, {imageId: undefined}); // hide the conference marker, imageId == undefined hides the marker

      // as conference leader, listen for internal view change event and fire conference view event
      // us.evVIEWCHANGE
      //            parms = {
      //                imageId:    required, imageId of selected image
      //                x:            required, view center X base coord in 'normal' graphics coord space
      //                y:            required, view center Y base coord in 'normal' graphics coord space
      //                zoom:        required, view zoom
      //                angleDeg:    optional, rotation angle in degrees
      //            };                $(us.idHashROOT).on(us.evVIEWCHANGE + namespace_, function (e, parms) {
      $(us.idHashROOT).on(us.evVIEWCHANGE + namespace_, function (e, parms) { // internal view change event
        if (parms.desc == 'move' || parms.desc == 'zoom' || parms.desc == 'rotate') {
          parms.src = 'uScope';
          var thisImg = uScope.getThisImageById(parms.imageId);
          if (thisImg) {
            var json = {
              'src': 'uScope',
              'imageId': parms.imageId,
              'uScopeIdx': parms.uScopeIdx,
              'x': parms.x,
              'y': parms.y,
              'z': '',
              'zoom': parms.zoom,
              'angleDeg': parms.angleDeg,
              'imagePath': thisImg.getFullURL()
            };
            logger.log('sending', confEvent.view, json);
            triggerConfEvent(confEvent.view, json); // fire event that conferencing leader's view has changed
          } else {
            logger.warn('conf: evVIEWCHANGE event received but I cannot get thisImage');
          }
        }
      });

      // as conference leader, listen for internal mouse change event and fire conference marker event
      // us.evMOUSECHANGE
      //            parms = {
      //                imageId:    required, imageId of selected image
      //                x:            required, X base coord of marker
      //                y:            required, Y base coord of marker
      //            };
      $(us.idHashROOT).on(us.evMOUSECHANGE + namespace_, function (e, parms) {
        if (uScope.isThisImageValid()) {
          var thisImg = uScope.getThisImage();
          var json = {
            'src': 'uScope',
            'imageId': parms.imageId,
            'uScopeIdx': thisImg.getImageIdx(),
            'MarkerX': parms.x,
            'MarkerY': parms.y,
            'imagePath': thisImg.getFullURL()
          };
          logger.log('sending', confEvent.marker, json);
          triggerConfEvent(confEvent.marker, json); // fire event for VIL that conferencing leader's view has changed
        }
      });

      //            ////////////////// temporary events for development prior to DST integration - single image operation ///////////////////
      //            // temporarily force a view change event to be sent on by VIL to conf server and on to conf participants
      //            if (uScope.isThisImageValid()) {
      //                var thisImg = uScope.getThisImage();
      //                eKey = jQuery.Event('', { type: 'keydown', which: us.keyCodes.arrowLeft }); // create keydown event
      //                vpKeyEvent(eKey, thisImg);
      //            }
      //            ////////////////// temporary events for development prior to DST integration - single image operation ///////////////////
    } else { // is conference follower
      // disable the next/prev slide toolbar buttons
      setIconState($('.' + us.clsTBNEXTSLIDE), us.clsTBNEXTSLIDE, 'disabled');
      setIconState($('.' + us.clsTBPREVSLIDE), us.clsTBPREVSLIDE, 'disabled');

      // a conference follower does not listen to internal view change events
      $(us.idHashROOT).off(us.evVIEWCHANGE + namespace_);

      // a conference follower does not listen to internal mouse change events
      $(us.idHashROOT).off(us.evMOUSECHANGE + namespace_);
    }
  };
    // ............................................ configure_ local
    //    configure_ -  This function informs viewport that a conference is starting or stopping
    //                    so that it can configure itself as necessary.
    //    parameters:
    //        inConference - required, boolen, true indicates joining conference;
    //                                        false indicates exiting conference;

  var configure_ = function (inConference) {
    var iScopeBtnExists = us.SHOWALLTOOLBARICONS || uScope.toolbarCanAddButton('openImageScopeBtn');
    if (inConference == true) {
      triggerConfEvent(us.evNAVMODEHALT, {uScopeIdx: -1});// fire event to halt navigation for all images

      uScope.events.trigger('us:conferencing:start');

      if (uScope.toolbarCanAddButton('dscSetupBtn')) { // give user feedback that conf is active by toolbar icon
        setIconState($('#' + CONSTANTS.CREATE_BUTTON_ID), CONSTANTS.CREATE_BUTTON_ID, 'active');
      }
      if (iScopeBtnExists) { // disable open-in-imagescope
        setIconState($('#' + us.TBISCOPE), us.TBISCOPE, 'disabled');
      }
      bindEvents_();
    } else { // not in conference
      bindEventsOff_();
      triggerUScopeEvent(CONSTANTS.CONFERENCE_MARKER_EVENT, {imageId: undefined}); // hide the conference marker, imageId == undefined hides the marker

      uScope.events.trigger('us:conferencing:finish');

      if (uScope.toolbarCanAddButton('dscSetupBtn')) { // change the toolbar icon to enabled if it is active
        setIconState($('#' + CONSTANTS.CREATE_BUTTON_ID), CONSTANTS.CREATE_BUTTON_ID, 'enabled');
      }
      if (iScopeBtnExists) {
        setIconState($('#' + us.TBISCOPE), us.TBISCOPE, 'enabled');
      }

      // enable the next/prev slide toolbar buttons
      setIconState($('.' + us.clsTBNEXTSLIDE), us.clsTBNEXTSLIDE, 'enabled');
      setIconState($('.' + us.clsTBPREVSLIDE), us.clsTBNEXTSLIDE, 'enabled');
    }
  };

    // ............................................ reportState public
  this.reportState = function () {
    var str = $t('not-in-conference');
    if (this.isConfLeader()) str = $t('is-conference-leader');
    else if (this.isConfMember()) str = $t('is-conference-member');
    return str;
  };

  // ............................................ reset_ local
  var reset_ = function () {
    bAmInConf_ = false;
    bAmLeader_ = false;
    confMarkerLT_.set(0, 0);
  };
    // ............................................ sendOpenImage_() local
  var sendOpenImage_ = function (opt_imageId) {
    var thisImg = (opt_imageId == undefined) ? uScope.getThisImage() : uScope.getThisImageById(opt_imageId);
    if (thisImg) {
      var imageId = thisImg.getImageId();
      // send 'normal' graphics coords
      var json = {
        src: 'uScope',
        imageId: imageId,
        uScopeIdx: thisImg.getImageIdx(),
        'imagePath': thisImg.getFullURL(),

        x: thisImg.getViewCenterX(true),
        y: thisImg.getViewCenterY(true),
        zoom: thisImg.getViewZoom(),
        angleDeg: thisImg.getViewAngle(true),

        MarkerX: thisImg.getViewCenterX(true),
        MarkerY: thisImg.getViewCenterY(true) // initially place the marker at the image center
      };
      logger.log('sending', confEvent.openimage, json);
      triggerConfEvent(confEvent.openimage, json); // fire event that the leader has opened an image
      return true;
    }
    return false;
  };
    // ............................................ construct_() local
  var construct_ = function () {
    reset_();

    // ............................................ confEvent.join
    var nspace = '.confStatic'; // these two events do not bind/unbind .....
    // Listen for a conference join event.
    $(document).on(confEvent.join + nspace, function (e, json) {
      if (self.isInConference() == false) {
        logger.log('recieved', confEvent.join, json);
        configure_(true); // enable/disable for conferencing - must be done prior to setting state to 'in-conference'

        bAmLeader_ = (json.lead == true);
        bAmInConf_ = true;

        if (bAmLeader_ == true) {
          uScope.closeAllButSelectedImage(); // close all but the currently selected image
          if (sendOpenImage_() == false) { // if leader has an image open, send the openimage event
            logger.warn('conf: leader: no image open yet');
          }
        }
        roleInit_(); // bind/unbind events depending upon leader/follower role
      }
    });
    // ............................................ confEvent.exit
    // Listen for a conference exit event.
    $(document).on(confEvent.exit + nspace, function (e, json) {
      if (self.isInConference() == true) {
        logger.log('received', confEvent.exit, json);
        reset_(); //
        configure_(false); //
      }
    });
  };

    // ............................................ construction
  construct_();
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/conferencing/conferencing-service.js